import { render, staticRenderFns } from "./shandong_push.vue?vue&type=template&id=ea8b55f2&scoped=true&"
import script from "./shandong_push.vue?vue&type=script&lang=js&"
export * from "./shandong_push.vue?vue&type=script&lang=js&"
import style0 from "./shandong_push.vue?vue&type=style&index=0&id=ea8b55f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea8b55f2",
  null
  
)

export default component.exports